import {
  AgreementPage,
  AuthPage,
  AuthTutorialPage,
  InputInfoPage,
  IntroPage,
  ResultPage,
  Terms,
  Tutorial,
} from "@components/pages";
import React from "react";

export interface RouteProps {
  path: string;
  component: React.FC;
  sessionRequired?: boolean;
}

const Routes: Array<RouteProps> = [
  {
    path: "/",
    component: IntroPage,
  },
  {
    path: "/test/:id",
    component: IntroPage,
  },
  {
    path: "/tutorial/1",
    component: Tutorial.Tutorial1Page,
  },
  {
    path: "/tutorial/2",
    component: Tutorial.Tutorial2Page,
  },
  {
    path: "/tutorial/3",
    component: Tutorial.Tutorial3Page,
  },
  {
    path: "/agree",
    component: AgreementPage,
  },
  {
    path: "/terms/terms",
    component: Terms.TermsPage,
  },
  {
    path: "/terms/privacy",
    component: Terms.PrivacyPage,
  },
  {
    path: "/terms/sensitive",
    component: Terms.SensitivePage,
  },
  {
    path: "/write_info",
    component: InputInfoPage,
  },
  {
    path: `/auth_tutorial`,
    component: AuthTutorialPage,
    sessionRequired: true,
  },
  {
    path: "/auth",
    component: AuthPage,
    sessionRequired: true,
  },
  {
    path: "/result",
    component: ResultPage,
    sessionRequired: true,
  },
  {
    path: "/*",
    component: IntroPage,
    sessionRequired: true,
  },
];

export default Routes;
